import { escapeHtml } from '../inventoree/format'

/**
 * `renderRich` din od_ai.js: raspunsul agentului, rand cu rand. Titlurile
 * (#), liniile (---), punctele de lista (- / 1.) si tabelele (|) se recunosc
 * dupa inceputul randului; inauntru, `cod`, **ingrosat**, *aplecat*. Textul
 * OMULUI nu trece pe aici - stelutele lui sunt ale lui.
 */
export function renderRich(text: string): string {
  const out: string[] = []
  for (const line of escapeHtml(text ?? '').split('\n')) {
    let m: RegExpMatchArray | null
    if (/^\s*---+\s*$/.test(line)) {
      out.push('<hr class="od-ai-rule">')
      continue
    }
    if ((m = line.match(/^\s*(#{1,6})\s+(.*)$/))) {
      out.push(`<span class="od-ai-h">${inline(m[2]!)}</span>`)
      continue
    }
    if ((m = line.match(/^\s*[-*]\s+(.*)$/))) {
      out.push(`<span class="od-ai-li">${inline(m[1]!)}</span>`)
      continue
    }
    if ((m = line.match(/^\s*(\d{1,2})[.)]\s+(.*)$/))) {
      out.push(`<span class="od-ai-li od-ai-num">${m[1]}. ${inline(m[2]!)}</span>`)
      continue
    }
    /* Randul de sub capul unui tabel (|---|---|) nu spune nimic unui om. */
    if (/^\s*\|?[\s:|-]*-[\s:|-]*\|?\s*$/.test(line) && line.includes('|')) continue
    if (/^\s*\|.*\|\s*$/.test(line)) {
      const cells = line
        .replace(/^\s*\|/, '')
        .replace(/\|\s*$/, '')
        .split('|')
      out.push(
        `<span class="od-ai-li">${cells
          .map((c) => inline(c.trim()))
          .filter((c) => c !== '')
          .join(' &middot; ')}</span>`,
      )
      continue
    }
    out.push(inline(line))
  }
  return out.join('\n')
}

function inline(t: string): string {
  return t
    .replace(/`([^`]+)`/g, '<code>$1</code>')
    .replace(/\*\*\*([^*]+)\*\*\*/g, '<strong>$1</strong>')
    .replace(/\*\*([^*]+)\*\*/g, '<strong>$1</strong>')
    .replace(/(^|[\s(])\*([^*\n]+)\*(?=[\s.,;:)]|$)/g, '$1<em>$2</em>')
}
